import createSvgIcon from '@mui/material/utils/createSvgIcon.js';
import React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M20 3H4c-.5523 0-1 .4477-1 1v16c0 .5523.4477 1 1 1h16c.5523 0 1-.4477 1-1V4c0-.5523-.4477-1-1-1M4.5 19.5v-15h15v15zm5.5007-12.36-2 2-1-1L5.94 9.2007l2.0607 2.0606 3.0606-3.0606zm-2 7.5 2-2 1.0606 1.0607-3.0606 3.0606L5.94 14.7007 7.0007 13.64zM12 15h4v1.5h-4zm5-2h-5v1.5h5zm-5-3.5h4V11h-4zm5-2h-5V9h5z"
    clipRule="evenodd"
  />,
  'List',
);
